import { CompactSpacing } from "@com.mgmtp.a12.widgets/widgets-core/lib/theme/compact/config/base/spacing.config";
import { HorizontalSpacingConfig, SpacingConfig, VerticalSpacingConfig } from "@com.mgmtp.a12.widgets/widgets-core/lib/theme/default/config/application/spacing.config";
import { defaultTheme } from "@com.mgmtp.a12.widgets/widgets-core/lib/theme/default/default-theme";
export function applyModulFSpacing(params) {
    return {
        ...params,
        spacing: params.compact
            ? {
                baseSpacing: CompactSpacing,
                spacing: SpacingConfig(CompactSpacing.BASE),
                horizontalSpacing: HorizontalSpacingConfig(CompactSpacing.BASE_HORIZONTAL_WHITE_SPACING),
                verticalSpacing: VerticalSpacingConfig(CompactSpacing.BASE_VERTICAL_WHITE_SPACING)
            }
            : defaultTheme.spacing
    };
}
